<ng-container *ngIf="visible">
  <p-button
    label="Request Translation"
    icon="fa fa-language"
    [loading]="loading"
    (onClick)="requestTranslation()"
    styleClass="p-ml-2"
  ></p-button>
</ng-container>
